import React, { useEffect, useState } from 'react'
import { useMutation, useQuery } from 'react-apollo-hooks'
import styled from 'react-emotion'
import Markdown from 'react-markdown'
import { Svg } from '../application'
import getText from '../booking/strings'
import { colors, Container } from '../styles'
import * as Mutations from './mutations'
import * as Queries from './queries'

const ModualContainer = styled('div')`
  margin: 0 10px 20px 10px;
`

const ModalHeader = styled('div')`
  display: flex;
  justify-content: space-between;

  .pictogram {
    height: 40px;
    width: 40px;
    cursor: pointer;
  }
`

const Header = styled('div')`
  margin: 20px 0 10px 0;

  .pictogram {
    height: 50px;
    width: 50px;
  }
`

const OptionsBox = styled('div')`
  border-top: 1px solid ${colors.tui_border};
  margin-top: 20px;
  padding-top: 20px;
  select {
    width: 300px;
    height: 40px;
    width: 100%;
  }

  textarea {
    height: 150px;
    width: 100%;
    margin-top: 20px;
  }

  input {
    width: 100%;
  }
`

const SelectedOptionContent = styled('div')`
  margin-top: 10px;
  button {
    margin-top: 10px;
  }
  ul {
    padding-left: 20px;
    list-style: unset;
  }
`

const Overview = ({ match }) => {
  const bookingNumber = match.params.bookingNumber
  const [options, setOptions] = useState([])
  const [selectedOption, setSelectedOption] = useState(null)
  const [submitted, setSubmitted] = useState(false)
  const [userMessage, setUserMessage] = useState('')

  const { loading, data, refetch } = useQuery(Queries.getSelfService(bookingNumber))
  const addCase = useMutation(Mutations.addSelfServiceCase)

  useEffect(() => {
    if (!loading && data && data.selfService && data.selfService.options) {
      setOptions([
        ...data.selfService.options,
        {
          id: '0',
          title: getText('selfservice', 'newCase', 'options', 'otherTitle'),
          description: getText('selfservice', 'newCase', 'options', 'otherDescription'),
        },
      ])
    }
  }, [data])

  const handleSelectedOption = (e) => {
    const option = options.filter((o) => o.id === e.target.value)[0]
    const selectedOption = option || null
    setSelectedOption(selectedOption)
  }

  const handleSubmit = () => {
    addCase({
      variables: {
        data: {
          bookingNumber: bookingNumber,
          id: selectedOption.id,
          message: userMessage,
        },
      },
    })
    setSubmitted(true)
  }

  if (submitted) {
    return (
      <Container>
        <Header>
          <Svg icon="tui-smile" />
        </Header>
        <ModalHeader>
          <div>
            <h2>{getText('selfservice', 'confirmation', 'title')}</h2>
          </div>
        </ModalHeader>
        <Markdown source={getText('selfservice', 'confirmation', 'description')} />
      </Container>
    )
  }

  return (
    <Container>
      <ModualContainer>
        <Header>
          <Svg icon="tui-smile" />
        </Header>
        <Header>
          <h2>{getText('selfservice', 'newCase', 'title')}</h2>
        </Header>
        <div>
          <strong>{getText('selfservice', 'newCase', 'bookingLabel')}</strong>: {bookingNumber}
          <p>{getText('selfservice', 'newCase', 'substring-1')}</p>
          <p>{getText('selfservice', 'newCase', 'substring-2')}</p>
        </div>
        <OptionsBox>
          <select onChange={(e) => handleSelectedOption(e)}>
            <option defaultValue>{getText('selfservice', 'newCase', 'options', 'placeholder')}</option>
            {options.map((o) => (
              <option value={o.id} key={o.id}>
                {o.title}
              </option>
            ))}
          </select>
          {selectedOption && (
            <SelectedOptionContent>
              <h3>{selectedOption.title}</h3>
              {selectedOption.id === '0' && <div dangerouslySetInnerHTML={{ __html: selectedOption.description }} />}
              {selectedOption.id !== '0' && (
                <div>
                  <Markdown source={selectedOption.description} linkTarget="_blank" />
                </div>
              )}
              {selectedOption.id !== '0' && (
                <div>
                  <textarea value={userMessage} onChange={(e) => setUserMessage(e.target.value)} placeholder={getText('selfservice', 'newCase', 'messagePlaceholder')} />
                  <button disabled={!userMessage.trim()} onClick={handleSubmit} className="btn btn-function">
                    {getText('selfservice', 'newCase', 'submit')}
                  </button>
                </div>
              )}
            </SelectedOptionContent>
          )}
        </OptionsBox>
      </ModualContainer>
    </Container>
  )

  // const [isModified, setIsModified] = useState(false)
  // const [hasValidationErrors, setHasValidationErrors] = useState(false)
  // const [isSaved, setIsSaved] = useState(false)
  // const [saving, setSaving] = useState(false)
  // const [error, setError] = useState(false)
  // const [atiForm, setAtiForm] = useState(null)

  // const { loading, data, error: atiError } = useQuery(Queries.getAti(bookingNumber))

  // useEffect(() => {
  //   setError(!!atiError)
  //   setAtiForm(data.ati)
  // }, [data, atiError])

  // const updateAti = useMutation(Mutations.updateAti, {
  //   update: (proxy, mutationResult) => {
  //     if (mutationResult.data.updateAti) {
  //       setSaving(false)
  //       setIsSaved(mutationResult.data.updateAti.UpdatedOk)
  //       setHasValidationErrors(!mutationResult.data.updateAti.UpdatedOk)
  //       setAtiForm(mutationResult.data.updateAti.ReservationAtiInformation)
  //       setIsModified(false)
  //     }
  //   },
  // })

  // const getDateMask = (label) => {
  //   if (label.indexOf('åååå-mm-dd') !== -1) {
  //     return '####-##-##'
  //   }
  //   return '##-##-####'
  // }

  // const handleClick = () => {
  //   window.scrollTo(0, 0)
  //   setSaving(true)
  //   setIsSaved(false)
  //   setError(false)
  //   setHasValidationErrors(false)

  //   updateAti({
  //     variables: {
  //       bookingNumber,
  //       data: {
  //         ReservationId: atiForm.ReservationId,
  //         Persons: atiForm.Persons.map((p) => ({
  //           ReservationPersonId: p.ReservationPersonId,
  //           Values: p.Values.map((v) => ({
  //             Key: v.Key,
  //             Value: v.Value,
  //           })),
  //         })),
  //       },
  //     },
  //   })
  // }

  // const createComponent = (personId, data) => {
  //   switch (data.Type) {
  //     case 'NATIONALITY':
  //       return (
  //         <FormContainer valid={data.ValidationMessageLocalized == null}>
  //           <label>{data.KeyLocalized}</label>
  //           <select defaultValue={data.Value} onChange={(e) => updateValue(personId, data.FieldId, e.target.value)}>
  //             {atiForm.Nationalities.map((n) => (
  //               <option key={n.Code} value={n.Code}>
  //                 {n.Name}
  //               </option>
  //             ))}
  //           </select>
  //           {data.ValidationMessageLocalized && <span>{data.ValidationMessageLocalized}</span>}
  //         </FormContainer>
  //       )
  //     case 'GENDER':
  //       if (data.Value === 'I')
  //         return (
  //           <FormContainer valid={data.ValidationMessageLocalized == null}>
  //             <label>{data.KeyLocalized}</label>
  //             <input type="text" value={getText('gender', 'infant')} readOnly={true} />
  //             {data.ValidationMessageLocalized && <span>{data.ValidationMessageLocalized}</span>}
  //           </FormContainer>
  //         )
  //       if (data.Value === 'C')
  //         return (
  //           <FormContainer valid={data.ValidationMessageLocalized == null}>
  //             <label>{data.KeyLocalized}</label>
  //             <input type="text" value={getText('gender', 'child')} readOnly={true} />
  //             {data.ValidationMessageLocalized && <span>{data.ValidationMessageLocalized}</span>}
  //           </FormContainer>
  //         )
  //       return (
  //         <FormContainer valid={data.ValidationMessageLocalized == null}>
  //           <label>{data.KeyLocalized}</label>
  //           <select defaultValue={data.Value} onChange={(e) => updateValue(personId, data.FieldId, e.target.value)}>
  //             <option key="" value="">
  //               {getText('gender', 'select')}
  //             </option>
  //             <option key="F" value="F">
  //               {getText('gender', 'female')}
  //             </option>
  //             <option key="M" value="M">
  //               {getText('gender', 'male')}
  //             </option>
  //           </select>
  //           {data.ValidationMessageLocalized && <span>{data.ValidationMessageLocalized}</span>}
  //         </FormContainer>
  //       )
  //     case 'DATE':
  //       return (
  //         <FormContainer valid={data.ValidationMessageLocalized == null}>
  //           <label>{data.KeyLocalized}</label>
  //           <NumberFormat format={getDateMask(data.KeyLocalized)} mask="" type="text" value={data.Value || ''} onChange={(e) => updateValue(personId, data.FieldId, e.target.value)} />
  //           {data.ValidationMessageLocalized && <span>{data.ValidationMessageLocalized}</span>}
  //         </FormContainer>
  //       )
  //     case 'STRING':
  //     default:
  //       return (
  //         <FormContainer valid={data.ValidationMessageLocalized == null}>
  //           <label>{data.KeyLocalized}</label>
  //           <input type="text" value={data.Value || ''} onChange={(e) => updateValue(personId, data.FieldId, e.target.value)} />
  //           {data.ValidationMessageLocalized && <span>{data.ValidationMessageLocalized}</span>}
  //         </FormContainer>
  //       )
  //   }
  // }

  // const updateValue = (personId, fieldId, value) => {
  //   const clone = { ...atiForm }
  //   clone.Persons.filter((p) => p.ReservationPersonId === personId)[0].Values.filter((p) => p.FieldId === fieldId)[0].Value = value
  //   setAtiForm(clone)
  //   setIsModified(true)
  // }

  // if (loading)
  //   return (
  //     <Container>
  //       <Loader />
  //     </Container>
  //   )

  // return (
  //   <Container>
  //     <ModualContainer>
  //       <Header>
  //         <Svg icon="tui-smile" />
  //       </Header>
  //       <TextErrors textErrors={getTextErrors()} />
  //       {saving && (
  //         <Message>
  //           <h3>{getText('saving')}</h3>
  //         </Message>
  //       )}
  //       {isSaved && (
  //         <Message>
  //           <h3>{getText('saved')}</h3>
  //           <div>{getText('savedText')}</div>
  //         </Message>
  //       )}
  //       {hasValidationErrors && (
  //         <Error>
  //           <h4>{getText('validationError')}</h4>
  //         </Error>
  //       )}
  //       {error && (
  //         <Error>
  //           <h3>{getText('generalError')}</h3>
  //         </Error>
  //       )}
  //       <Header>
  //         <h2>{getText('title')}</h2>
  //         <div>
  //           <strong>{getText('description1')}</strong>
  //         </div>
  //         <div>
  //           <a href={urls.passportAndVisa}>{getText('linkText')}</a>&nbsp;
  //           {getText('description2')}
  //         </div>
  //       </Header>
  //       <h2>{bookingNumber}</h2>
  //       {atiForm &&
  //         atiForm.Persons.length > 0 &&
  //         atiForm.Persons.map((p) => (
  //           <Person key={p.ReservationPersonId}>
  //             <Name>{p.DisplayName}</Name>
  //             <Fields>
  //               {p.Values.map((v) => (
  //                 <div key={v.FieldId}>{createComponent(p.ReservationPersonId, v)}</div>
  //               ))}
  //             </Fields>
  //           </Person>
  //         ))}
  //       <ButtonRow>
  //         {atiForm && (
  //           <button className="btn btn-function" onClick={() => handleClick()}>
  //             {getText('save')}
  //           </button>
  //         )}
  //       </ButtonRow>
  //     </ModualContainer>
  //   </Container>
  // )
}

export default Overview
